<template>
	<div class="purchase-page">
		<Loader :show="loading" />

		<div class="head-page">
			<div>
				<div class="btn " @click="$router.go(-1)">
					<i class="icon icon-left-open-big"></i>
				</div>
			</div>
		</div>

		<div v-if="membershipType && !loading" class="content">
			<FormulateForm name="form" v-model="formUser" style="max-width:100%" @submit="purchase">
				<div class="card">
					<div class="card-body pb-4 mb-5">
						<div class="d-flex align-items-center">
							<div class="vip">
								<h4>VIP</h4>
								<h5>PASS</h5>
							</div>
							<div class="data">
								Hacete miembro VIP de {{ membershipType.account.name }}
								<h3>{{ membershipType.name }}</h3>
							</div>
						</div>
						<div class="label mt-4">Condiciones de la membresía:</div>
						<div v-html="membershipType.description"></div>
					</div>
				</div>

				<div class="card" v-if="!$store.getters.isAuthenticated && !user">
					<div class="card-body">
						<h4 class="mb-0">Mis datos</h4>
						<p class="mb-3">
							¿Ya tienes cuenta en CobraTicket?

							<router-link tag="a" :to="`/login?redirectTo=${$route.path}`" class="text-primary"
								>Inicia sesión</router-link
							>
						</p>

						<div class="row row-xs mb-3">
							<div class="col-12 col-md-6">
								<FormulateInput
									label="Nombre"
									name="name"
									validation-name="Nombre"
									validation="required"
								/>
							</div>
							<div class="col-12 col-md-6">
								<FormulateInput
									label="Apellido"
									name="lastname"
									validation-name="Apellido"
									validation="required"
								/>
							</div>
						</div>
						<div class="row row-xs mb-3">
							<div class="col-12 col-md-6">
								<FormulateInput
									label="Documento de identidad"
									type="identification"
									name="document"
									validation-name="Documento de identidad"
									validation="bail|required|documentID"
								/>
							</div>
							<div class="col-12 col-md-6">
								<FormulateInput
									label="Teléfono"
									type="phone"
									name="phone"
									validation-name="Teléfono"
									validation="optional|^phone"
								/>
							</div>
						</div>
						<div class="row row-xs mb-3">
							<div class="col-12 col-md-6">
								<FormulateInput
									label="Correo electrónico"
									type="email"
									name="email"
									validation-name="Email"
									validation="required|email"
								/>
							</div>
							<div class="col-12 col-md-6">
								<FormulateInput
									label="Confirmar correo electrónico"
									type="email"
									name="email_confirm"
									validation-name="Confirmar email"
									validation="required|email|confirm"
								/>
							</div>
						</div>
					</div>
				</div>

				<div class="card " v-if="order">
					<div class="card-body">
						<h4 class="mb-3">Resumen del pedido</h4>

						<div class="p-4 cart">
							<div class="cart-item">
								<p>
									sadasdasd
								</p>
								<div>$ {{ membershipType.price }}</div>
							</div>
							<div class="cart-item">
								<p>Cargo por servicio</p>
								<div>$ {{ order.commission }}</div>
							</div>
							<div class="cart-total">
								<span>Total</span>
								<span>$ {{ order.total }}</span>
							</div>
						</div>

						<div class="alert">
							Al hacer clic en "Finalizar compra", acepto los términos de servicio y he leído la política
							de privacidad. Acepto que CobraTicket pueda compartir mi información con el organizador del
							evento.
						</div>

						<div class="foot">
							<div class="btn btn-lg btn-primary btn-block" @click="$formulate.submit('form')">
								<span v-if="saving">Finalizando compra <span class="btn-loader" /> </span>
								<span v-else>Finalizar compra y pagar</span>
							</div>
						</div>
					</div>
				</div>
			</FormulateForm>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Loader from "@/components/Loader"

export default {
	name: "MembershipPurchase",
	components: {
		Loader
	},
	data() {
		return {
			loading: false,
			saving: false,
			order: null,
			membershipType: null,
			user: null,
			formUser: {
				name: "",
				lastname: "",
				document: { number: null, type: "UY" },
				email: "",
				phone: {
					countryCode: "UY"
				}
			}
		}
	},

	async beforeMount() {
		this.loading = true
		await this.loadMembershipType()
		if (this.$store.getters.isAuthenticated) {
			this.user = this.$store.getters.loggedUser
		}
		await this.orderCreate()
	},
	methods: {
		// cargo la orden
		loadMembershipType() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($code: String!) {
							membershipType(code: $code) {
								id
								name
								description
								account {
									id
									name
								}
								image {
									id
									url
								}
								price
							}
						}
					`,
					variables: {
						code: this.$route.params.code
					}
				})
				.then(({ data }) => {
					this.membershipType = data.membershipType
					this.loading = false
					return data.membershipType
				})
		},

		// proceso para finalizar la compra
		async purchase() {
			console.log(" purchase")
			if (!this.saving) {
				this.saving = true

				if (!this.$store.getters.isAuthenticated) {
					this.user = await this.userCreate()
					if (!this.user) {
						this.saving = false
						return
					}
				}

				const order = await this.orderConfirm()
				if (!order) throw new Error("Error al confirmar la orden")

				const transaction = await this.transactionCreate()
				if (transaction) {
					// redirecciono a la pagina de pago
					if (transaction.paymentRedirectUrl) {
						window.location.href = transaction.paymentRedirectUrl
					}
				}
			}
		},

		// creo al usuario
		userCreate() {
			let data = {
				name: this.formUser.name,
				lastname: this.formUser.lastname,
				document: this.formUser.document,
				email: this.formUser.email,
				phone: this.formUser.phone
			}
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: UserInput!) {
							userCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data
					}
				})
				.then(({ data }) => {
					return data.userCreate
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		},

		// confirmo la orden
		async orderCreate() {
			let data = {
				membershipTypeId: this.membershipType.id,
				userId: this.$store.getters.isAuthenticated ? this.$store.getters.loggedUser.id : null
			}
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: OrderInput!) {
							orderCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data
					}
				})
				.then(async ({ data }) => {
					this.order = await this.loadOrder(data.orderCreate.id)
					return data.orderCreate
				})
				.catch((error) => {
					this.parseGQLErrors(error)
				})
		},

		loadOrder(id) {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							order(id: $id) {
								id
								membership {
									id
								}
								user {
									id
									name
									lastname
									phone {
										countryCode
										national
										international
										type
										validated
									}
									email
									document {
										type
										number
									}
								}
								reservedAt
								subtotal
								commission
								total
								status
								statusText
								statusClass
							}
						}
					`,
					variables: {
						id
					}
				})
				.then(({ data }) => {
					if (data.order.status == "CANCELLED") {
						this.$router.go(-1)
						return null
					}

					// this.order = this.$omitDeep(data.order, "__typename")
					// // si la orden ya tiene usuario, lo cargo a form
					// if (data.order.user) {
					// 	this.form.user[0] = {
					// 		name: data.order.user.name,
					// 		lastname: data.order.user.lastname,
					// 		document: data.order.user.document,
					// 		email: data.order.user.email,
					// 		phone: data.order.user.phone
					// 	}
					// 	console.log(this.form)
					// }
					return data.order
				})
		},

		async orderConfirm() {
			let data = {
				userId: this.user.id
			}

			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: OrderInput!) {
							orderConfirm(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.order.id,
						data
					}
				})
				.then(({ data }) => {
					return data.orderConfirm
				})
				.catch((error) => {
					this.parseGQLErrors(error)
				})
		},

		// creo la transaccion
		async transactionCreate() {
			console.log("transactionCreate")

			let data = {
				orderId: this.order.id
			}

			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: TransactionInput!) {
							transactionCreate(data: $data) {
								id
								paymentRedirectUrl
							}
						}
					`,
					variables: {
						data
					}
				})
				.then(({ data }) => {
					console.log("transactionCreate return", data.transactionCreate)
					return data.transactionCreate
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.head-page {
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	max-width: 700px;
	width: 100%;

	i {
		color: #fff;
		font-size: 20px;
	}
}

.card {
	width: 100%;
	border-radius: 4px;
	margin-bottom: 24px;
}

.purchase-page {
	position: relative;
	overflow: hidden;
	z-index: 0;
	min-height: 400px;
	background-color: #fff;

	display: flex;
	flex-direction: column;

	align-items: center;
	justify-content: center;

	&:before {
		display: block;
		content: "";
		position: absolute;
		top: 200px;
		left: 50%;
		transform: translateX(-50%);
		min-width: 2000px;
		width: 100%;
		z-index: -1;
		height: 200px;
		background: rgb(0, 0, 0);
		clip-path: polygon(0px 0px, 100% 0px, 100% 0px, 0px 100%);
	}
	&:after {
		display: block;
		content: "";
		position: absolute;
		top: 0px;
		left: 0px;
		right: 0px;
		height: 201px;
		background: rgb(0, 0, 0);
		z-index: -1;
	}

	.content {
		max-width: 700px;
		border-radius: 8px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		border: none;

		position: relative;
		min-height: 600px;

		& /deep/ .event-data .image {
			width: 180px;
			height: 180px;
		}
	}
}

.cart {
	.label {
		font-weight: 500;
		color: #1e0a3c;
		font-size: 0.875rem;
		line-height: 1.25rem;
	}

	.cart-item {
		width: 100%;
		display: flex;
		justify-content: space-between;

		p {
			font-size: 0.95rem;
			font-weight: 500;
		}
	}

	.cart-total {
		border-top: 1px solid #eeedf2;
		padding: 16px 0px;
		font-weight: 500;
		font-size: 1.25rem;
		display: flex;
		justify-content: space-between;
	}
}

.remainingTimer {
	position: fixed;
	bottom: 12px;
	right: 12px;

	background-color: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 2;
	font-size: 1.1rem;
	color: rgb(168, 168, 168);
	font-weight: 500;
	border-radius: 22px;
	padding: 4px 12px;
	box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);

	.icon {
		width: 16px;
		height: 16px;
		margin-right: 4px;
	}
	span {
		display: none;
	}
	&.warning {
		background-color: #ffc107;
		color: #fff;
		span {
			display: inline-block;
			font-size: 0.9rem;
			margin-left: 8px;
		}
	}
}
.alert {
	color: #6f7287;
	background-color: #f8f7fa;
}

.vip {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 20px 10px 20px 20px;
	border-right: 4px dotted #fff;

	h4 {
		font-size: 3.2rem;
		font-weight: bold;
		line-height: 3rem;
		margin-top: 5px;
	}
	h5 {
		font-size: 1.12em;
		font-weight: bold;
		margin-left: -6px;
		transform: rotate(270deg);
	}
}
</style>
